module.exports = __webpack_public_path__ + "img/spin_btn.cde72127.png";